
    import React from 'react'
    const rootRoute = { childRoutes: [{childRoutes: [
      {
        path:'/react-gravatar/',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            let Component = require('/Users/kylemathews/programs/react-gravatar/www/pages/index.js')
            if (Component.default) {
              Component = Component.default
            }
            require.ensure([], (require) => {
              const data = require('./json/2899072733.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---index')
          }, 'page-component---pages-index-js')
        }
      },
    ]},]}
    module.exports = rootRoute


/** WEBPACK FOOTER **
 ** ../.intermediate-representation/split-child-routes.js
 **/